import { useTranslation } from 'react-i18next';

import Button from '@/components/Button';
import { DialogFooter, DialogTop } from '@/components/Dialog';
import Print from '@/icons/print-document.svg';

function PrintDocumentContent({ onOpenChange, onSubmit, loading }) {
	const { t } = useTranslation();

	return (
		<>
			<DialogTop
				title={t('myDocuments.modals.printDocument.title')}
				description={t('myDocuments.modals.printDocument.description')}
			/>

			<div className="flex flex-col items-center gap-2 px-4 py-9">
				<Print />
				<p className="whitespace-pre-line text-center text-sm text-grey-500">
					{t('myDocuments.modals.printDocument.text')}
				</p>
			</div>

			<DialogFooter>
				<Button variant="outline" onClick={() => onOpenChange(false)}>
					{t('common.cancel')}
				</Button>
				<Button onClick={onSubmit} loading={loading}>
					{t('common.print')}
				</Button>
			</DialogFooter>
		</>
	);
}

export default PrintDocumentContent;
